export default __webpack_public_path__ + "static/media/CovidVaccineRegistration.ed6499d9.svg";